module.exports = __webpack_public_path__ + "static/media/rahul.36145e64.jpg";